import React, { useEffect, useCallback, useRef, useState, useMemo } from "react";

import Users from "./External_users";
import Selected from "./External_selected";
import Projects from "./External_projects";

const UserAuthExternal = (props, ref) => {
    const [SelectedUser, SetSelectedUser] = useState(null);
    const SelectedRef = useRef(null);
    const ProjectsRef = useRef(null);

    const addProject = (data) => {
        SelectedRef.current?.addProject(data);
    };
    const filterProject = (data) => {
        ProjectsRef.current.filterProject(data);
    };
    return (
        <div style={{ marginTop: "2rem" }}>
            <div className={"wrapper"} style={{ justifyContent: "flex-start", gap: "30px" }}>
                <Users SetSelectedUser={SetSelectedUser} />
                {SelectedUser && <Selected ref={SelectedRef} selectedUser={SelectedUser} filterProject={filterProject} />}
                <Projects ref={ProjectsRef} addProject={addProject} selectedUser={SelectedUser} />
            </div>
        </div>
    );
};

export default UserAuthExternal;
